import React from "react";
import ToggleButton from "react-bootstrap/ToggleButton";

const SwToggleButtons = ({
  id,
  name,
  value,
  checked,
  onChange,
  disabled = false,

  type = "radio",       // radio | checkbox
  size = "md",           // md | sm | xs

  className = "",
  children,
  ...rest
}) => {
  return (
    <ToggleButton
      id={id}
      type={type}
      name={name}
      value={value}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      className={`sw-toggle-btn sw-toggle-btn-${size} ${className}`}
      {...rest}
    >
      {children}
    </ToggleButton>
  );
};

export default SwToggleButtons;
